import React, { useState, useEffect } from 'react'
import teacher from "../imgs/teacher.png"
import { Button, Form, Row, Col } from "react-bootstrap"
import Fade from 'react-reveal/Fade';
import InputField from '../components/InputField';
import { useStateMachine } from "little-state-machine";
import { useForm } from "react-hook-form";
import updateAction from "../updateAction";
import * as yup from "yup";
import { Navigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup"
import { Helmet } from 'react-helmet'
import { useNavigate } from "react-router-dom";

const Sstep4 = (props) => {
    let navigate = useNavigate();
    const [showSpouse, setshowSpouse] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "all"
        , resolver: yupResolver(schema)
    });
    const { state, actions } = useStateMachine({ updateAction });

    const onSubmit = data => {
        console.log(data);
        actions.updateAction(data);
        navigate("/Sstep5", { replace: true });
    };

    const [go, setgo] = useState(false);

    useEffect(() => {
        if (!state.firstname) {
            setgo(true);
        }
    });

    return (
        <>
            <Helmet>
                <title>Registration</title>
            </Helmet>
            {go && (
                <Navigate to='/Sstep1' />
            )}
            <div className="bg"></div>
            <div className="bg bg2"></div>
            <div className="bg bg3"></div>
            {/* <div className="content"> */}

            <div className="container1">

                <div className="wrapper1">
                    <ul className="steps">
                        <li className="is-active">Step 5 of 6</li>
                    </ul>
                    <form className="form-wrapper1" onSubmit={handleSubmit(onSubmit)}>

                        <fieldset className="section is-active">
                            <Fade>
                                <>
                                    <h3>Welcome, {state.firstname}</h3>
                                    <p>Tell us a little more about yourself</p>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Are you signing up for the diploma or short courses</Form.Label>
                                        <select className="form-select"{...register("program")} name="program"
                                            onChange={(e) => {
                                                if (e.target.value === "Short courses") {
                                                    setshowSpouse(true);
                                                } else {
                                                    setshowSpouse(false);
                                                }
                                            }}
                                            required>
                                            <option></option>
                                            <option value="Diploma">Diploma</option>
                                            <option value="Short courses">Short courses</option>
                                        </select>

                                        {showSpouse && (
                                            <Fade>
                                                <>
                                                    <InputField register={register} name="courses" errorinfo={errors} label="Enter the short courses you are signing up for" as="textarea" />
                                                </>
                                            </Fade>
                                        )}

                                    </Form.Group>

                                    <p>Do you agree that you have been saved for more than two years? <input className="form-check-input"{...register("saved", { required: true })} type="checkbox" value="1" required /></p>
                                    <p>To complete this registration please visit any branch to make your down payment. Please call to make an appointment. Tel: 1-868-399-0887 Registration Fee: $300 (Non Refundable) do you accept? <input className="form-check-input"{...register("complete", { required: true })} type="checkbox" value="I accept" required /></p>
                                    <Button type="submit">Next</Button>
                                </>
                            </Fade>
                        </fieldset>

                    </form>
                </div>
            </div>


            {/* </div> */}
        </>
    )
}
const schema = yup.object().shape({
    courses: yup.string().when("program", {
        is: "Short courses",
        then: yup.string().required("enter the courses you are planning on doing")
    })
})


export default Sstep4
